import { render, staticRenderFns } from "./SendFirebaseNotification.vue?vue&type=template&id=1a993d59&"
import script from "./SendFirebaseNotification.vue?vue&type=script&lang=js&"
export * from "./SendFirebaseNotification.vue?vue&type=script&lang=js&"
import style0 from "./SendFirebaseNotification.vue?vue&type=style&index=0&id=1a993d59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports